import { type ClassValue, clsx } from "clsx";
import * as React from "react";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "2xs-caption",
        "display-xs",
        "display-sm",
        "display-md",
        "display-lg",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// matchMedia can't run during SSR — pass the same `initialValue` on both sides or hydration mismatches.
export function useMediaQuery(query: string, initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }
    const result = matchMedia(query);
    result.addEventListener("change", onChange);
    setValue(result.matches);
    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return value;
}
